angular.module('eatself').component('collapseContainer',{
	bindings: {
		open: '<',
		maxHeight: '@',
		style: '@',
	},
	transclude: true,
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
		inject: ['$element','$timeout'],
		methods: {
			$onChanges() {
				// because of the transition delay 500ms, hidden: immediately; visible: after 500ms
				if (this.open) {
					this.$timeout(_ => this.open && this.$element.children().css('overflow','visible'),500)
				} else {
					this.$element.children().css('overflow','hidden')
				}
			}
		}
	}),
	template: `
	<div ng-style="{ 'max-height': vm.open?vm.maxHeight:0 }" style="transition: max-height 500ms ease-in-out">
		<ng-transclude style="{{vm.style}}"></ng-transclude>
	<div>
	`,
})